import React, { useState, useEffect, Children } from "react";
import { EmployeeDataVM, EmployeeTeamVM } from "../../Models/ViewModels";
import { Table, Pagination, Stack, Avatar, Input, Button } from "rsuite";
import "./EmployeeTeamsList.css";
import * as ProfileDB from "../../Services/EmployeeDB";
import { PageHeader } from "../../SharedComponents/PageHeader";
import { EmployeeBadge } from "./EmployeeBadge";
import { EmployeeTeamModal } from "./EmployeeTeamModalDisp";
import { BootstrapIcon } from "../../SharedComponents/BootstrapIcon";
import { handleDownloadAsExcel } from "../../Helpers/Utils";
import { GetUserLoginID } from "../../Services/UserSessionManager";
import { CustomTableCell } from "../../SharedComponents/CustomTableCell";
import { CustomTableHeaderCell } from "../../SharedComponents/CustomTableHeaderCell";
import { Dropdown, DropdownButton, Form, InputGroup } from "react-bootstrap";

const { Column, HeaderCell, Cell } = Table;
const colors = ["pink", "grey", "blue", "yellow", "purple", "green", "red"];

export const EmployeeTeamsList = ({ name, designation, department }: any) => {
  const [cachedEmployeesList, setCachedEmployeesList] = useState(
    new Array<EmployeeTeamVM>()
  );
  const [sortColumn, setSortColumn] = useState();
  const [isLoading, setLoading] = useState(true);
  const [sortType, setSortType] = useState();
  const [page, setPage] = React.useState(1);
  const [limit, setLimit] = React.useState(15);
  const [filteredEmployeesList, setFilteredEmployeesList] = useState(
    new Array<EmployeeTeamVM>()
  );
  const [loginid, setLoginid] = useState(GetUserLoginID());
  const [searching, setSearching] = useState(false);
  const [uploadDate, setUploadDate] = useState([]);
  const [searchby, setSearchBy] = useState("Dropdown");
  const [searchby2, setSearchBy2] = useState("Dropdown");

  useEffect(() => {
    getAllEmployeesList(loginid);
    GetUploadDate();
  }, []);

  const handleFilterData = (val: string, e: any) => {
    let searchText = val;
    setPage(1);
    if (searchText) {
      setFilteredEmployeesList(
        cachedEmployeesList.filter((e) =>
          JSON.stringify(e).toLowerCase().includes(searchText.toLowerCase())
        )
      );
      setSearching(true);
    } else {
      setFilteredEmployeesList([...cachedEmployeesList]);
      setSearching(false);
    }
  };

  const filterData = () => {
    setPage(1);
    let search1value = (document.getElementById("Search1") as HTMLInputElement)
      .value;
    let search2value = (document.getElementById("Search2") as HTMLInputElement)
      .value;

    setFilteredEmployeesList(
      cachedEmployeesList.filter(
        (e) =>
          includesSearchValue(e, searchby, search1value) &&
          includesSearchValue(e, searchby2, search2value)
      )
    );
  };
  const includesSearchValue = (
    e: EmployeeTeamVM,
    searchBy: string,
    searchText: string
  ) => {
    switch (searchBy) {
      case "ID":
        return e.EmployeeID.toLowerCase().includes(searchText.toLowerCase());

      case "Name":
        return e.EmployeeName.toLowerCase().includes(searchText.toLowerCase());

      case "Reporting PM 1":
        return e.ReportingOfficerID1.toLowerCase().includes(
          searchText.toLowerCase()
        );
      case "Reporting PM 2":
        return e.ReportingOfficerID2.toLowerCase().includes(
          searchText.toLowerCase()
        );

      case "Team":
        return e.TeamName.toLowerCase().includes(searchText.toLowerCase());

      case "Process":
        return e.ProcessName.toLowerCase().includes(searchText.toLowerCase());

      case "Shift":
        return e.Shift.toLowerCase().includes(searchText.toLowerCase());
      case "Department":
        return e.Department.toLowerCase().includes(searchText.toLowerCase());
      case "Branch":
        return e.Branch.toLowerCase().includes(searchText.toLowerCase());

      default:
        return JSON.stringify(e)
          .toLowerCase()
          .includes(searchText.toLowerCase());
    }
  };

  const tableDataFeed = filteredEmployeesList.filter((v, i) => {
    const start = limit * (page - 1);
    const end = start + limit;
    return i >= start && i < end;
  });
  const handleChangeLimit = (dataKey: any) => {
    setPage(1);
    setLimit(dataKey);
  };

  const getAllEmployeesList = (loginid: any) => {
    ProfileDB.GetEmployeeTeam(loginid)
      .then((res) => {
        if (res.data) {
          setCachedEmployeesList(res.data);
          setFilteredEmployeesList(res.data);
          setLoading(false);
        }
      })
      .catch((err) => {
        console.log("fail");
      });
  };

  const handleSortColumn = (sortColumn: any, sortType: any) => {
    setLoading(true);
    setTimeout(() => {
      setLoading(false);
      setSortColumn(sortColumn);
      setSortType(sortType);
    }, 500);

    if (sortColumn && sortType) {
      return filteredEmployeesList.sort((a: any, b: any) => {
        let x = a[sortColumn];
        let y = b[sortColumn];
        if (typeof x === "string" || "") {
          x = x.charCodeAt();
        }
        if (typeof y === "string" || "") {
          y = y.charCodeAt();
        }
        if (sortType === "asc") {
          return x - y;
        } else {
          return y - x;
        }
      });
    }
  };
  const GetUploadDate = () => {
    ProfileDB.GetLastUploaded().then((resp) => {
      setUploadDate(resp.data);
    });
  };

  const employeeTeamInfo: EmployeeTeamVM = new EmployeeTeamVM();
  const addEmployee = (empDetail: EmployeeTeamVM) => {
    getAllEmployeesList(loginid);
  };
  const editEmployee = (empDetail: EmployeeTeamVM) => {
    getAllEmployeesList(loginid);
  };
  const deleteEmployee = (empDetail: EmployeeTeamVM) => {
    getAllEmployeesList(loginid);
  };

  const SearchBy = (value: any) => {
    setSearchBy(value);
  };
  const SearchBy2 = (value: any) => {
    setSearchBy2(value);
  };
  return (
    <>
      <div className="row">
        <div className="col-md-4">
          <PageHeader title="Manage Teams" backPage="">
            <></>
          </PageHeader>
        </div>
        <div className="col-md-3">
          <InputGroup className="mb-3">
            <DropdownButton
              variant="outline-secondary"
              title={searchby}
              id="input-group-dropdown-1"
            >
              <Dropdown.Item href="#" onClick={() => SearchBy("ID")}>
                ID
              </Dropdown.Item>
              <Dropdown.Item href="#" onClick={() => SearchBy("Name")}>
                Name
              </Dropdown.Item>
              <Dropdown.Item href="#" onClick={() => SearchBy("Team")}>
                Team
              </Dropdown.Item>
              <Dropdown.Item href="#" onClick={() => SearchBy("SubTeam")}>
                Sub Team
              </Dropdown.Item>
              <Dropdown.Item href="#" onClick={() => SearchBy("Process")}>
                Process
              </Dropdown.Item>
              <Dropdown.Item href="#" onClick={() => SearchBy("Shift")}>
                Shift
              </Dropdown.Item>
              <Dropdown.Item href="#" onClick={() => SearchBy("Department")}>
                Department
              </Dropdown.Item>
              <Dropdown.Item href="#" onClick={() => SearchBy("Branch")}>
                Branch
              </Dropdown.Item>
              <Dropdown.Item
                href="#"
                onClick={() => SearchBy("Reporting PM 1")}
              >
                Reporting PM 1
              </Dropdown.Item>
              <Dropdown.Item
                href="#"
                onClick={() => SearchBy("Reporting PM 2")}
              >
                Reporting PM 2
              </Dropdown.Item>
              <Dropdown.Item href="#" onClick={() => SearchBy("Dropdown")}>
                Default
              </Dropdown.Item>
            </DropdownButton>
            <Form.Control
              aria-label="Text input with dropdown button"
              id="Search1"
              onChange={(event) => filterData()}
              placeholder="Search..."
            />
          </InputGroup>
        </div>
        <div className="col-md-3">
          {/* <Input className="form-control border border-dark"  placeholder="Search..." type={'search'} id='search' onChange={handleFilterData} />         */}
          <InputGroup className="mb-3">
            <DropdownButton
              variant="outline-secondary"
              title={searchby2}
              id="input-group-dropdown-1"
            >
              <Dropdown.Item href="#" onClick={() => SearchBy2("ID")}>
                ID
              </Dropdown.Item>
              <Dropdown.Item href="#" onClick={() => SearchBy2("Name")}>
                Name
              </Dropdown.Item>
              <Dropdown.Item href="#" onClick={() => SearchBy2("Team")}>
                Team
              </Dropdown.Item>
              <Dropdown.Item href="#" onClick={() => SearchBy2("SubTeam")}>
                Sub Team
              </Dropdown.Item>
              <Dropdown.Item href="#" onClick={() => SearchBy2("Process")}>
                Process
              </Dropdown.Item>
              <Dropdown.Item href="#" onClick={() => SearchBy2("Shift")}>
                Shift
              </Dropdown.Item>
              <Dropdown.Item href="#" onClick={() => SearchBy("Department")}>
                Department
              </Dropdown.Item>
              <Dropdown.Item href="#" onClick={() => SearchBy("Branch")}>
                Branch
              </Dropdown.Item>
              <Dropdown.Item
                href="#"
                onClick={() => SearchBy2("Reporting PM 1")}
              >
                Reporting PM 1
              </Dropdown.Item>
              <Dropdown.Item
                href="#"
                onClick={() => SearchBy2("Reporting PM 2")}
              >
                Reporting PM 2
              </Dropdown.Item>
              <Dropdown.Item href="#" onClick={() => SearchBy2("Dropdown")}>
                Default
              </Dropdown.Item>
            </DropdownButton>
            <Form.Control
              aria-label="Text input with dropdown button"
              onChange={(event) => filterData()}
              placeholder="Search..."
              id="Search2"
            />
          </InputGroup>
        </div>
        <div className="col-md-1">
          {searching == true ? (
            <button
              id="color"
              onClick={() => handleDownloadAsExcel(tableDataFeed)}
            >
              <BootstrapIcon
                bootStrapIconName={"file-earmark-arrow-down-fill"}
                size={35}
                cssClasses={"pe-2"}
              />{" "}
            </button>
          ) : (
            <button
              id="color"
              onClick={() => handleDownloadAsExcel(cachedEmployeesList)}
            >
              <BootstrapIcon
                bootStrapIconName={"file-earmark-arrow-down-fill"}
                size={35}
                cssClasses={"pe-2"}
              />
              {""}
            </button>
          )}
        </div>
        <div className="col">
          <EmployeeTeamModal
            action="add"
            data={employeeTeamInfo}
            cachedData={cachedEmployeesList}
            onAction={addEmployee}
          />
          <br />
        </div>
        <hr />
      </div>

      <div className="show-container" bg-color="pink">
        <Table
          id="table"
          data={tableDataFeed}
          loading={isLoading}
          sortColumn={sortColumn}
          sortType={sortType}
          onSortColumn={handleSortColumn}
          bordered={true}
          cellBordered={true}
          className="border border-dark mt-2"
          autoHeight={true}
          rowHeight={30}
          headerHeight={30}
        >
          <Column width={50} align="center" resizable sortable>
            <CustomTableHeaderCell placement={"ID"}>ID</CustomTableHeaderCell>
            <CustomTableCell dataKey="EmployeeID" />
          </Column>

          <Column width={170} resizable sortable>
            <CustomTableHeaderCell placement={"Name"}>
              Name
            </CustomTableHeaderCell>
            <CustomTableCell dataKey="EmployeeName" />
          </Column>
          <Column width={100} resizable>
            <CustomTableHeaderCell placement={"Designation"}>
              Designation
            </CustomTableHeaderCell>
            <CustomTableCell dataKey="Designation" />
          </Column>

          <Column width={140} sortable resizable>
            <CustomTableHeaderCell placement={"Team"}>
              Team
            </CustomTableHeaderCell>
            <CustomTableCell dataKey="TeamName" />
          </Column>

          <Column width={80} sortable resizable>
            <CustomTableHeaderCell placement={"SubTeam"}>
              SubTeam
            </CustomTableHeaderCell>
            <CustomTableCell dataKey="SubTeamName" />
          </Column>
          <Column width={80} sortable resizable>
            <CustomTableHeaderCell placement={"Process"}>
              Process
            </CustomTableHeaderCell>
            <CustomTableCell dataKey="ProcessName" />
          </Column>
          <Column width={50} resizable>
            <CustomTableHeaderCell placement={"Allocation%"}>
              Allocation%
            </CustomTableHeaderCell>
            <CustomTableCell dataKey="AllocationPercent" />
          </Column>
          <Column width={50} resizable>
            <CustomTableHeaderCell placement={"Buffer%"}>
              Buffer%
            </CustomTableHeaderCell>
            <CustomTableCell dataKey="BufferPercent" />
          </Column>
          <Column width={70} resizable>
            <CustomTableHeaderCell placement={"Shift"}>
              Shift
            </CustomTableHeaderCell>
            <CustomTableCell dataKey="Shift" />
          </Column>

          <Column width={100} resizable>
            <CustomTableHeaderCell placement={"Department"}>
              Department
            </CustomTableHeaderCell>
            <CustomTableCell dataKey="Department" />
          </Column>

          <Column width={80} resizable>
            <CustomTableHeaderCell placement={"Branch"}>
              Branch
            </CustomTableHeaderCell>
            <CustomTableCell dataKey="Branch" />
          </Column>
          <Column width={140} resizable>
            <CustomTableHeaderCell placement={"Reporting PM1"}>
              Reporting PM1
            </CustomTableHeaderCell>
            <CustomTableCell dataKey="ReportingOfficerID1" />
          </Column>
          <Column width={150} resizable>
            <CustomTableHeaderCell placement={"Reporting PM2"}>
              Reporting PM2
            </CustomTableHeaderCell>
            <CustomTableCell dataKey="ReportingOfficerID2" />
          </Column>
          <Column flexGrow={30}>
            <CustomTableHeaderCell></CustomTableHeaderCell>
            <CustomTableCell>
              {(rowData: EmployeeTeamVM) => {
                return (
                  <div className="d-flex justify-content-start align-items-center flex-row gap-4">
                    <EmployeeTeamModal
                      action="delete"
                      data={rowData}
                      cachedData={cachedEmployeesList}
                      onAction={deleteEmployee}
                    />
                    <EmployeeTeamModal
                      action="edit"
                      data={rowData}
                      cachedData={cachedEmployeesList}
                      onAction={editEmployee}
                    />
                  </div>
                );
              }}
            </CustomTableCell>
          </Column>
        </Table>

        {filteredEmployeesList && (
          <div style={{ padding: 20 }}>
            <Pagination
              prev
              next
              first
              last
              ellipsis
              boundaryLinks
              maxButtons={5}
              size="md"
              layout={["total", "-", "limit", "|", "pager", "skip"]}
              total={filteredEmployeesList.length}
              limitOptions={[10, 15, 20, 25, 30]}
              limit={limit}
              activePage={page}
              onChangePage={setPage}
              onChangeLimit={handleChangeLimit}
            />
          </div>
        )}
        <div className="row">
          <div className="col-md-10"></div>
          <div className="col-md-2">
            <p>
              <b>Last Uploaded On :</b> {uploadDate}
            </p>
          </div>
        </div>
      </div>
    </>
  );
};
